export const firebaseConfig = {
    apiKey: "AIzaSyAcBZRgJLuf5saXMKA7mYsaQUmyv_4H96g",
    authDomain: "bridgehireapp.firebaseapp.com",
    projectId: "bridgehireapp",
    storageBucket: "bridgehireapp.firebasestorage.app",
    messagingSenderId: "208478925540",
    appId: "1:208478925540:web:29ca0c436a04877f74b2f1",
    measurementId: "G-315JRL9TN9"
};